import React from 'react';
import classnames from 'classnames';
import { OutboundLink } from 'gatsby-plugin-google-analytics';
import setLang from '../../utils/setLang';
import './game-logo.scss';

const getSignUpUrl = (accountSubDomain, serviceCode) =>
  `https://${accountSubDomain}/signup/index?serviceCode=${serviceCode}`;

const GameLogo = ({ content, game, handleLogoHover, currentGame, currentLang }) => {
  const classList = classnames('game-logo', game, `${currentGame}-theme`, {
    active: game === currentGame,
  });

  const urlLang = content.languageMapping[currentLang];
  const urlServiceCode = content.serviceCodes[game];

  return (
    <OutboundLink
      className={classList}
      onMouseEnter={() => handleLogoHover(game)}
      onClick={() => { setLang(urlLang); }}
      href={getSignUpUrl(process.env.GATSBY_NC_ACCOUNT_DOMAIN, urlServiceCode)}
    />
  );
}

export default GameLogo
